import { render, staticRenderFns } from "./TeamsOverview.vue?vue&type=template&id=0777b238&scoped=true&"
import script from "./TeamsOverview.vue?vue&type=script&lang=js&"
export * from "./TeamsOverview.vue?vue&type=script&lang=js&"
import style0 from "./TeamsOverview.vue?vue&type=style&index=0&id=0777b238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0777b238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
